import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Trends from './pages/Trends';
import Heatmap from './pages/Heatmap';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Documentation from './pages/Documentation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import APIReference from './pages/APIReference';
import TermsOfService from './pages/TermsOfService';

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="trends" element={<Trends />} />
          <Route path="heatmap" element={<Heatmap />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="documentation" element={<Documentation />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="api-reference" element={<APIReference />} />
          <Route path="terms-of-service" element={<TermsOfService />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;